import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const PHONE_SUPPORT_SCHEMA = Object.freeze({
  NUMBER: '',
  DESCRIPTION: '',
  TITLE: '',
});
export const RECORD = generateSchema(PHONE_SUPPORT_SCHEMA);
export const KEYS: any = generateKeys(PHONE_SUPPORT_SCHEMA);

export class PhoneSupport extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get number(): string {
    return this.get(KEYS.NUMBER);
  }

  get description(): string {
    return this.get(KEYS.DESCRIPTION);
  }

  get title(): string {
    return this.get(KEYS.TITLE);
  }
}
